/* assets/socks-pdp-pack-selector.js
 * In-page diabetic socks PDP pack selector.
 * Owns only the submitted variant id; theme.js still owns add-to-cart.
 */
(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-socks-pdp-pack-selector]';
  var CONFIG_SELECTOR = '[data-socks-pdp-pack-selector-config]';
  var MIX_HANDLE = 'dr-fuss-u-bojama-mix-2-2-2';

  function parseConfig(root) {
    var node = root.querySelector(CONFIG_SELECTOR);
    if (!node) return null;

    try {
      return JSON.parse(node.textContent || '{}');
    } catch (error) {
      console.warn('[socks-pdp-pack-selector] Invalid config', error);
      return null;
    }
  }

  function normalize(value) {
    return value === null || typeof value === 'undefined' ? '' : String(value).trim();
  }

  function formatMoney(cents, config) {
    if (window.theme && window.theme.Currency && typeof window.theme.Currency.formatMoney === 'function') {
      return window.theme.Currency.formatMoney(cents, (window.theme && window.theme.moneyFormat) || (config && config.moneyFormat));
    }

    var amount = (parseInt(cents, 10) || 0) / 100;
    return amount.toLocaleString(undefined, { style: 'currency', currency: 'EUR' });
  }

  function findSection(root) {
    return root.closest('[data-section-type="product"]') || document;
  }

  function getSelectedOptions(section) {
    return Array.prototype.slice.call(section.querySelectorAll('.single-option-selector[data-index]')).map(function (select) {
      return {
        index: select.getAttribute('data-index'),
        name: normalize(select.getAttribute('data-option-name')).toLowerCase(),
        value: normalize(select.value)
      };
    }).filter(function (option) {
      return option.index;
    });
  }

  function exactOptionMatch(variant, selectedOptions, pack) {
    if (!variant || !selectedOptions.length) return false;
    return selectedOptions.every(function (option) {
      var variantKey = option.index;
      if (pack && pack.options && option.name) {
        var packOptionIndex = pack.options.findIndex(function (name) {
          return normalize(name).toLowerCase() === option.name;
        });
        if (packOptionIndex !== -1) variantKey = 'option' + (packOptionIndex + 1);
      }
      return normalize(variant[variantKey]) === option.value;
    });
  }

  function titleMatch(variant, selectedOptions) {
    if (!variant || selectedOptions.length !== 1) return false;
    var value = selectedOptions[0].value;
    return normalize(variant.title) === value || normalize(variant.option1) === value;
  }

  function resolveVariant(pack, selectedOptions) {
    if (!pack || !pack.variants || !pack.variants.length) return null;

    if (!selectedOptions.length) {
      return pack.variants.find(function (variant) { return variant.available; }) || pack.variants[0];
    }

    var exactAvailable = pack.variants.find(function (variant) {
      return variant.available && exactOptionMatch(variant, selectedOptions, pack);
    });
    if (exactAvailable) return exactAvailable;

    var exact = pack.variants.find(function (variant) {
      return exactOptionMatch(variant, selectedOptions, pack);
    });
    if (exact) return exact;

    var titleAvailable = pack.variants.find(function (variant) {
      return variant.available && titleMatch(variant, selectedOptions);
    });
    if (titleAvailable) return titleAvailable;

    var title = pack.variants.find(function (variant) {
      return titleMatch(variant, selectedOptions);
    });
    if (title) return title;

    return null;
  }

  function Controller(root) {
    this.root = root;
    this.config = parseConfig(root);
    if (!this.config || !this.config.packs || !this.config.packs.length) return;

    this.section = findSection(root);
    this.form = root.closest('form') || this.section.querySelector('[data-product-form]');
    this.hiddenInput = root.querySelector('[data-socks-pdp-selected-variant-id]');
    this.cards = Array.prototype.slice.call(root.querySelectorAll('[data-socks-pdp-pack-card]'));
    this.addButton = this.form ? this.form.querySelector('[data-add-to-cart]') : null;
    this.addButtonText = this.addButton ? this.addButton.querySelector('[data-add-to-cart-text]') : null;
    this.priceContainer = this.section.querySelector('[data-price]');
    this.sizeGroup = this.form ? this.form.querySelector('.product_swatches') : null;
    this.inventory = this.form ? this.form.querySelector('.inventory_qty_info') : null;
    this.purchaseSummary = null;
    this.activePackHandle = this.config.initialPackHandle || this.config.packs[0].handle;
    this.activeVariant = null;

    if (this.form) this.form.classList.add('socks-purchase-flow');
    this.enhancePackData();
    this.decorateCards();
    this.decoratePurchaseFlow();
    this.bindEvents();
    this.sync(true);
  }

  Controller.prototype.getPack = function (handle) {
    return this.config.packs.find(function (pack) { return pack.handle === handle; }) || this.config.packs[0];
  };

  Controller.prototype.getBasePack = function () {
    return this.config.packs.find(function (pack) { return parseInt(pack.multiplier, 10) === 1; }) || this.config.packs[0];
  };

  Controller.prototype.isMixedPack = function (pack) {
    return !!(pack && pack.handle === MIX_HANDLE);
  };

  Controller.prototype.enhancePackData = function () {
    this.config.packs.forEach(function (pack) {
      if (pack.handle === MIX_HANDLE) {
        pack.label = 'Mix 2+2+2';
        pack.pairCount = 6;
        pack.multiplier = 3;
        pack.requiresDedicatedPage = true;
      }
    });
  };

  Controller.prototype.formatPairLabel = function (pack) {
    if (this.isMixedPack(pack)) return 'Mix 2+2+2';
    var pairCount = parseInt(pack && pack.pairCount, 10) || 0;
    if (!pairCount) return normalize(pack && pack.label);
    var strings = this.config.strings || {};
    var pairLabel = pairCount === 2 || pairCount === 4
      ? (strings.pairsTwoFour || 'para')
      : (strings.pairsOther || 'pari');
    return pairCount + ' ' + pairLabel;
  };

  Controller.prototype.decorateCards = function () {
    var self = this;
    var strings = this.config.strings || {};
    this.cards.forEach(function (card) {
      var pack = self.getPack(card.getAttribute('data-pack-handle'));
      var label = card.querySelector('.socks-pdp-pack-selector__label');
      if (label) label.textContent = self.formatPairLabel(pack);

      if (!self.isMixedPack(pack)) return;

      card.classList.add('is-mixed-pack');
      card.setAttribute('data-pack-url', pack.url || '');
      card.setAttribute('aria-label', strings.mixAria || 'Mix 2+2+2: 2 plava, 2 siva i 2 bež para. Jedna veličina vrijedi za cijeli komplet.');

      var title = card.querySelector('.socks-pdp-pack-selector__title');
      if (title) title.textContent = strings.mixTitle || 'Komplet svih boja';

      if (!card.querySelector('.socks-pdp-pack-selector__mix-summary')) {
        var summary = document.createElement('span');
        summary.className = 'socks-pdp-pack-selector__mix-summary';

        var badge = document.createElement('strong');
        badge.className = 'socks-pdp-pack-selector__mix-badge';
        badge.textContent = strings.mixBadge || 'Sve 3 boje';
        summary.appendChild(badge);

        var composition = document.createElement('span');
        composition.className = 'socks-pdp-pack-selector__mix-composition';
        ['blue', 'blue', 'gray', 'gray', 'beige', 'beige'].forEach(function (color) {
          var dot = document.createElement('i');
          dot.className = 'socks-pdp-pack-selector__mix-dot is-' + color;
          dot.setAttribute('aria-hidden', 'true');
          composition.appendChild(dot);
        });
        var compositionText = document.createElement('span');
        compositionText.textContent = strings.mixComposition || '2 plava + 2 siva + 2 bež';
        composition.appendChild(compositionText);
        summary.appendChild(composition);

        var sizeText = document.createElement('span');
        sizeText.className = 'socks-pdp-pack-selector__mix-size';
        sizeText.textContent = strings.mixSize || 'Jedna veličina za svih 6 pari →';
        summary.appendChild(sizeText);

        var price = card.querySelector('.socks-pdp-pack-selector__price');
        card.insertBefore(summary, price || null);
      }
    });
  };

  Controller.prototype.decoratePurchaseFlow = function () {
    var strings = this.config.strings || {};
    var packHeading = this.root.querySelector('.socks-pdp-pack-selector__heading');
    var sizeHeading = this.sizeGroup ? this.sizeGroup.querySelector('.swatch .header') : null;

    if (packHeading) packHeading.textContent = strings.packStep || '1. Choose a pack';
    if (sizeHeading) sizeHeading.textContent = strings.sizeStep || '2. Choose your size';
    var composition = this.form ? this.form.querySelector('.product_description_accrordion') : null;
    var trustBlock = this.form ? this.form.querySelector('.image_with_text_blocks') : null;
    if (composition && trustBlock && trustBlock.parentNode) {
      trustBlock.parentNode.insertBefore(composition, trustBlock.nextSibling);
    }
    if (!this.form || this.purchaseSummary) return;

    var summary = document.createElement('div');
    summary.className = 'socks-purchase-summary';
    summary.setAttribute('aria-live', 'polite');
    var check = document.createElement('span');
    check.className = 'socks-purchase-summary__check';
    check.setAttribute('aria-hidden', 'true');
    check.textContent = '\u2713';
    summary.appendChild(check);

    var body = document.createElement('span');
    body.className = 'socks-purchase-summary__body';
    var selection = document.createElement('span');
    selection.className = 'socks-purchase-summary__selection';
    selection.setAttribute('data-socks-purchase-selection', '');
    var shipping = document.createElement('span');
    shipping.className = 'socks-purchase-summary__shipping';
    shipping.setAttribute('data-socks-purchase-shipping', '');
    body.appendChild(selection);
    body.appendChild(shipping);
    summary.appendChild(body);

    var anchor = this.inventory || (this.form.querySelector('.product-form__controls-group--submit'));
    if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(summary, anchor);
    this.purchaseSummary = summary;
  };

  Controller.prototype.bindEvents = function () {
    var self = this;

    this.cards.forEach(function (card) {
      card.addEventListener('click', function (event) {
        event.preventDefault();
        if (card.disabled || card.classList.contains('is-disabled')) return;
        var nextHandle = card.getAttribute('data-pack-handle') || self.activePackHandle;
        var nextPack = self.getPack(nextHandle);
        if (self.isMixedPack(nextPack) && nextPack.url) {
          window.location.assign(nextPack.url);
          return;
        }
        self.activePackHandle = nextHandle;
        self.sync(false);
      });
    });

    this.section.addEventListener('variantChange', function () {
      window.setTimeout(function () {
        self.sync(false);
      }, 0);
    });

    if (this.form) {
      this.form.addEventListener('change', function (event) {
        if (event.target && event.target.matches && event.target.matches('.single-option-selector[data-index]')) {
          window.setTimeout(function () {
            self.sync(false);
          }, 0);
        }
      });
    }

    if (this.addButton) {
      this.addButton.addEventListener('click', function () {
        document.body.classList.add('socks-cart-context');
      });
    }
  };

  Controller.prototype.sync = function (isInitial) {
    var selectedOptions = getSelectedOptions(this.section);
    var activePack = this.getPack(this.activePackHandle);
    var activeVariant = resolveVariant(activePack, selectedOptions);
    this.activeVariant = activeVariant;

    this.updateCards(selectedOptions, activePack);
    this.updateSubmittedVariant(activeVariant);
    this.updateAddButton(activeVariant);
    this.updateProductPrice(activeVariant);
    this.updatePurchaseSummary(activePack, activeVariant, selectedOptions);
    this.dispatchPackChange(activePack, activeVariant, isInitial);
  };

  Controller.prototype.updateCards = function (selectedOptions, activePack) {
    var self = this;
    var basePack = this.getBasePack();
    var baseVariant = resolveVariant(basePack, selectedOptions);

    this.cards.forEach(function (card) {
      var pack = self.getPack(card.getAttribute('data-pack-handle'));
      var variant = resolveVariant(pack, selectedOptions);
      var isActive = pack.handle === activePack.handle;
      var isAvailable = !!(variant && variant.available);
      var price = card.querySelector('[data-socks-pdp-pack-price]');
      var saving = card.querySelector('[data-socks-pdp-pack-saving]');
      var compare = card.querySelector('[data-socks-pdp-pack-compare]');

      if (!compare && price) {
        compare = document.createElement('s');
        compare.className = 'socks-pdp-pack-selector__compare';
        compare.setAttribute('data-socks-pdp-pack-compare', '');
        price.parentNode.insertBefore(compare, price);
      }

      card.classList.toggle('is-selected', isActive);
      card.classList.toggle('is-disabled', !isAvailable);
      card.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      card.disabled = !isAvailable;

      if (price && variant) {
        price.textContent = formatMoney(variant.price, self.config);
      }

      if (saving) {
        var multiplier = parseInt(pack.multiplier, 10) || 1;
        var compareAtPrice = variant ? parseInt(variant.compareAtPrice, 10) || 0 : 0;
        var reference = compareAtPrice > (variant ? variant.price : 0)
          ? compareAtPrice
          : (baseVariant && baseVariant.price ? baseVariant.price * multiplier : 0);
        var savingsAmount = variant && reference > variant.price ? reference - variant.price : 0;
        if (compare) {
          compare.textContent = savingsAmount > 0 ? formatMoney(reference, self.config) : '';
          compare.hidden = savingsAmount <= 0;
        }
        if (savingsAmount > 0) {
          var saveTemplate = (self.config.strings && self.config.strings.save) || 'Save [amount]';
          var savingsPercent = Math.round((savingsAmount / reference) * 100);
          saving.textContent = '−' + savingsPercent + '% · ' + saveTemplate.replace('[amount]', formatMoney(savingsAmount, self.config));
          saving.hidden = false;
        } else {
          saving.hidden = true;
        }
      }

      var labelText = self.formatPairLabel(pack);
      var priceText = price ? normalize(price.textContent) : '';
      var savingText = saving && !saving.hidden ? normalize(saving.textContent) : '';
      card.setAttribute('aria-label', [labelText, priceText, savingText].filter(Boolean).join(', '));
    });
  };

  Controller.prototype.updatePurchaseSummary = function (pack, variant, selectedOptions) {
    if (!this.purchaseSummary || !variant) return;
    var strings = this.config.strings || {};
    var selection = this.purchaseSummary.querySelector('[data-socks-purchase-selection]');
    var shipping = this.purchaseSummary.querySelector('[data-socks-purchase-shipping]');
    var sizes = selectedOptions.map(function (option) { return option.value; }).filter(Boolean).join(' / ');
    var parts = [this.formatPairLabel(pack)];
    if (sizes) parts.push((strings.sizeLabel || 'size') + ' ' + sizes);
    parts.push(formatMoney(variant.price, this.config));

    if (selection) {
      selection.textContent = (strings.selected || 'Selected') + ': ' + parts.join(' \u00b7 ');
    }

    if (shipping) {
      var threshold = parseInt(this.config.freeShippingThreshold, 10) || 0;
      var remaining = Math.max(0, threshold - (parseInt(variant.price, 10) || 0));
      if (!threshold || remaining <= 0) {
        shipping.textContent = strings.freeShipping || 'Free shipping included';
        shipping.classList.add('is-qualified');
      } else {
        shipping.textContent = (strings.freeShippingRemaining || '[amount] away from free shipping').replace('[amount]', formatMoney(remaining, this.config));
        shipping.classList.remove('is-qualified');
      }
    }
  };

  Controller.prototype.updateSubmittedVariant = function (variant) {
    if (!this.hiddenInput) return;
    this.hiddenInput.value = variant && variant.available ? variant.id : '';
    this.hiddenInput.dispatchEvent(new Event('change', { bubbles: true }));
  };

  Controller.prototype.updateProductPrice = function (variant) {
    if (!this.priceContainer || !variant) return;
    var price = formatMoney(variant.price, this.config);
    var compareAtPrice = parseInt(variant.compareAtPrice, 10) || 0;
    var isOnSale = compareAtPrice > variant.price;
    var regularPrices = this.priceContainer.querySelectorAll('[data-regular-price]');
    var salePrice = this.priceContainer.querySelector('[data-sale-price]');

    this.priceContainer.classList.toggle('price--sold-out', !variant.available);
    this.priceContainer.classList.toggle('price--on-sale', isOnSale);

    regularPrices.forEach(function (node) {
      node.textContent = isOnSale ? formatMoney(compareAtPrice, this.config) : price;
    }, this);

    if (salePrice) {
      salePrice.textContent = price;
    }
  };

  Controller.prototype.updateAddButton = function (variant) {
    if (!this.addButton) return;
    var available = !!(variant && variant.available);
    this.addButton.disabled = !available;
    if (available) {
      this.addButton.removeAttribute('aria-disabled');
    } else {
      this.addButton.setAttribute('aria-disabled', 'true');
    }

    if (this.addButtonText) {
      if (available) {
        var addLabel = (window.theme && window.theme.productStrings && window.theme.productStrings.addToCart) || (window.theme && window.theme.strings && window.theme.strings.addToCart) || (this.config.strings && this.config.strings.addToCart) || 'Add to cart';
        this.addButtonText.textContent = addLabel + ' · ' + formatMoney(variant.price, this.config);
      } else {
        this.addButtonText.textContent = (window.theme && window.theme.productStrings && window.theme.productStrings.soldOut) || (window.theme && window.theme.strings && window.theme.strings.soldOut) || (this.config.strings && this.config.strings.soldOut) || 'Sold out';
      }
    }
  };

  Controller.prototype.dispatchPackChange = function (pack, variant, isInitial) {
    var detail = {
      packKey: pack.key,
      packHandle: pack.handle,
      productId: pack.productId,
      variantId: variant ? variant.id : null,
      variant: variant,
      pack: pack,
      qualifiesForBundle: !!pack.qualifiesForBundle,
      isInitial: !!isInitial
    };

    this.root.dispatchEvent(new CustomEvent('socks:pdp-pack-change', {
      detail: detail,
      bubbles: true
    }));
  };

  function init() {
    var roots = document.querySelectorAll(ROOT_SELECTOR);
    roots.forEach(function (root) {
      if (root.__socksPdpPackSelector) return;
      root.__socksPdpPackSelector = new Controller(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () {
    init();
  });
})();
